// import React from "react";

// const PuneMumbaiInfo = () => {
//   return (
//   <>
  
//      <div className="breadcrumb-bar">
//         <div className="container">
//           <div className="row align-items-center text-center">
//             <div className="col-md-12 col-12">
//               <h2 className="breadcrumb-title">Pune ↔ Mumbai ↔ Pune Cabs</h2>
//             </div>
//           </div>
//         </div>
//       </div>

  
//     <div className="container py-5">

//       {/* Pune to Mumbai */}
//       <div className="row align-items-center mb-5">
        
//         <div className="col-md-5">
//           <img 
//             src="/images/keyword/1.jpg" 
//             alt="Pune to Mumbai Cab"
//             className="img-fluid rounded"
//           />
//         </div>

//         <div className="col-md-7">
//           <h2>Pune to Mumbai Cab Service</h2>
//           <h5 className="darkcolorrr">Estimated Travel Time: 3–4 Hours</h5>

//           <p>
//             Planning a trip from Pune to Mumbai? Velocity Cab offers reliable and 
//             comfortable cab services designed for smooth intercity travel. Whether 
//             you're heading for business meetings, airport transfers, or a weekend 
//             getaway, our service ensures a stress-free experience from start to finish.
//           </p>

//           <p>
//             The route via expressway provides a fast and scenic drive through the 
//             Western Ghats. Our professional drivers are experienced and well-trained 
//             to handle long-distance travel, ensuring safety and punctuality at every step.
//           </p>

//           <p>
//             Choose from a range of vehicles including sedan, SUV, and premium cars. 
//             All vehicles are clean, well-maintained, and equipped for a comfortable journey.
//           </p>
//         </div>

//       </div>

//       {/* Mumbai to Pune */}
//       <div className="row align-items-center flex-md-row-reverse">
        
//         <div className="col-md-5">
//           <img 
//             src="/images/keyword/103.jpg" 
//             alt="Mumbai to Pune Cab"
//             className="img-fluid rounded"
//           />
//         </div>

//         <div className="col-md-7">
//           <h2>Mumbai to Pune Cab Service</h2>
//           <h5 className="darkcolorrr">Estimated Travel Time: 3–4 Hours</h5>

//           <p>
//             Travel from Mumbai to Pune with ease using Velocity Cab’s trusted cab services. 
//             Whether you’re leaving from the airport, railway station, or any location in Mumbai, 
//             we provide door-to-door pickup and drop for maximum convenience.
//           </p>

//           <p>
//             Enjoy a relaxed journey through the Mumbai–Pune Expressway with beautiful landscapes 
//             and smooth roads. Our drivers are familiar with traffic patterns and take the best 
//             routes to save your time.
//           </p>

//           <p>
//             We offer flexible options including one-way trips, round trips, and customized travel 
//             packages. With affordable pricing and 24/7 availability, Velocity Cab is your perfect 
//             travel partner.
//           </p>
//         </div>

//       </div>

//     </div>
//   </>
//   );
// };

// export default PuneMumbaiInfo;













import React from "react";

const PuneMumbaiInfo = () => {
  return (
    <>
      <div className="breadcrumb-bar">
        <div className="container text-center">
          <h2 className="breadcrumb-title">Pune ↔ Mumbai ↔ Pune Cabs</h2>
        </div>
      </div>

      <div className="container py-5">

        {/* Pune to Mumbai */}
        <div className="row align-items-center mb-5">
          <div className="col-md-5">
            <img
              src="/images/keyword/1.jpg"
              alt="Pune to Mumbai Cab"
              className="img-fluid rounded"
            />

              {/* RATE UI */}
            <div className="rate-card mt-4">
              <h4>Cab Fare (One Way)</h4>

              <div className="rate-item">
                <span>🚗 Sedan (Dzire / Etios)</span>
                <strong>₹2600</strong>
              </div>

              <div className="rate-item">
                <span>🚙 SUV (Ertiga / Innova)</span>
                <strong>₹3200</strong>
              </div>

              <div className="rate-item">
                <span>🚘 Innova Crysta</span>
                <strong>₹4500</strong>
              </div>

            </div>
          </div>


          <div className="col-md-7">
            <h2>Pune to Mumbai Cab Service</h2>
            <h5 className="darkcolorrr">Estimated Travel Time: 3–4 Hours</h5>

            {/* ORIGINAL CONTENT */}
            <p>
              Planning a trip from Pune to Mumbai? Velocity Cab offers reliable and 
              comfortable cab services designed for smooth intercity travel. Whether 
              you're heading for business meetings, airport transfers, or a weekend 
              getaway, our service ensures a stress-free experience from start to finish.
            </p>

            <p>
              The route via expressway provides a fast and scenic drive through the 
              Western Ghats. Our professional drivers are experienced and well-trained 
              to handle long-distance travel, ensuring safety and punctuality at every step.
            </p>

            <p>
              Choose from a range of vehicles including sedan, SUV, and premium cars. 
              All vehicles are clean, well-maintained, and equipped for a comfortable journey.
            </p>

            {/* WHY CHOOSE */}
            <div className="why-box mt-4">
              <h4>Why Choose Velocity Cabs</h4>
              <ul>
                <li>✔ 24/7 Available Cab Service</li>
                <li>✔ Expert Drivers for Expressway Travel</li>
                <li>✔ Clean & Comfortable AC Vehicles</li>
                <li>✔ Door-to-Door Pickup & Drop</li>
                <li>✔ Transparent Pricing – No Hidden Charges</li>
              </ul>
            </div>

          

          </div>
        </div>

        {/* Mumbai to Pune */}
        <div className="row align-items-center flex-md-row-reverse">
          <div className="col-md-5">
            <img
              src="/images/keyword/103.jpg"
              alt="Mumbai to Pune Cab"
              className="img-fluid rounded"
            />

    {/* RATE UI */}
            <div className="rate-card mt-4">
              <h4>Cab Fare (One Way)</h4>

              <div className="rate-item">
                <span>🚗 Sedan (Dzire / Etios)</span>
                <strong>₹2600</strong>
              </div>

              <div className="rate-item">
                <span>🚙 SUV (Ertiga / Innova)</span>
                <strong>₹3200</strong>
              </div>

              <div className="rate-item">
                <span>🚘 Innova Crysta</span>
                <strong>₹4500</strong>
              </div>

            </div>


          </div>

          <div className="col-md-7">
            <h2>Mumbai to Pune Cab Service</h2>
            <h5 className="darkcolorrr">Estimated Travel Time: 3–4 Hours</h5>

            {/* ORIGINAL CONTENT */}
            <p>
              Travel from Mumbai to Pune with ease using Velocity Cab’s trusted cab services. 
              Whether you’re leaving from the airport, railway station, or any location in Mumbai, 
              we provide door-to-door pickup and drop for maximum convenience.
            </p>

            <p>
              Enjoy a relaxed journey through the Mumbai–Pune Expressway with beautiful landscapes 
              and smooth roads. Our drivers are familiar with traffic patterns and take the best 
              routes to save your time.
            </p>

            <p>
              We offer flexible options including one-way trips, round trips, and customized travel 
              packages. With affordable pricing and 24/7 availability, Velocity Cab is your perfect 
              travel partner.
            </p>

            {/* WHY CHOOSE */}
            <div className="why-box mt-4">
              <h4>Why Choose Velocity Cabs</h4>
              <ul>
                <li>✔ Airport Pickup Experts (T1 / T2 / T3)</li>
                <li>✔ On-Time Pickup Guarantee</li>
                <li>✔ Safe & Professional Drivers</li>
                <li>✔ Comfortable Long-Distance Travel</li>
                <li>✔ Affordable One-Way Pricing</li>
              </ul>
            </div>

        
          </div>
        </div>

      </div>
    </>
  );
};

export default PuneMumbaiInfo;